import { render, staticRenderFns } from "./PaginationRetoucher.vue?vue&type=template&id=0d4c5997&"
import script from "./PaginationRetoucher.vue?vue&type=script&lang=js&"
export * from "./PaginationRetoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports